import { render, staticRenderFns } from "./MapMapping.vue?vue&type=template&id=5b319e23&scoped=true"
import script from "./MapMapping.vue?vue&type=script&lang=js"
export * from "./MapMapping.vue?vue&type=script&lang=js"
import style0 from "./MapMapping.vue?vue&type=style&index=0&id=5b319e23&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b319e23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\ideaWorkSpace\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b319e23')) {
      api.createRecord('5b319e23', component.options)
    } else {
      api.reload('5b319e23', component.options)
    }
    module.hot.accept("./MapMapping.vue?vue&type=template&id=5b319e23&scoped=true", function () {
      api.rerender('5b319e23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/senior/MapMapping.vue"
export default component.exports